// src/components/ReferralTracker.js
import { collectionKeys } from "@core/helper/utils";
import { useEffect } from "react";
// Use this everywhere
const { getFirestore, doc, getDocs, increment, query, setDoc, updateDoc, where, collection } = require("firebase/firestore");

const ReferralTracker = ({ firestoreConfig }) => {
  const db = firestoreConfig;
  useEffect(() => {
    if (typeof window !== "undefined") {
      const searchParams = new URLSearchParams(window.location.search);
      const referealId = searchParams.get("ref") || "";
      const utm_source = (searchParams.get("utm_source") || "").toLowerCase();
      const keyword = searchParams.get("keyword") || "";
      
      if (referealId) {
        const q = query(
          collection(db, collectionKeys.REFERAL),
          where("referealId", "==", referealId)
        );

        const handleReferral = async () => {
          const querySnapshot = await getDocs(q);
          if (!querySnapshot.empty) {
            const matchingDoc = querySnapshot.docs.find(
              (doc) => doc.data().utm_source === utm_source && doc.data().keyword === keyword
            );
            if (matchingDoc) {
              await updateDoc(matchingDoc.ref, {
                views: increment(1),
                updatedAt: new Date(),
              });
            } else {
              const newDocRef = doc(collection(db, collectionKeys.REFERAL));
              await setDoc(newDocRef, {
                keyword,
                utm_source,
                referealId,
                views: 1,
                createdAt: new Date(),
                updatedAt: new Date(),
              });
            }
          }
          // } else {
          //   const newDocRef = doc(collection(db, collectionKeys.REFERAL));
          //   await setDoc(newDocRef, {
          //     keyword,
          //     utm_source,
          //     referealId,
          //     views: 1,
          //     createdAt: new Date(),
          //     updatedAt: new Date(),
          //   });
          // }
        };

        handleReferral();
      }
    }
  }, [db]);

  return null;
};

export default ReferralTracker;
